import { Button } from '@heroui/react';
import styled from 'styled-components';

import { ds } from '@/config/colors';
import { media } from '@/utils/mediaQueries';

/* Główne CTA wg DS: atrament na jasnym tle, odwrócone w ciemnym motywie (jak ekrany auth). */
export const LogoutButton = styled(Button)`
  margin-top: 24px;
  height: 44px;
  min-width: 160px;
  padding: 0 24px;
  background: ${({ theme }) => (theme.mode === 'dark' ? ds.bgSurface : ds.accentInk)};
  color: ${({ theme }) => (theme.mode === 'dark' ? ds.accentInk : ds.bgSurface)};

  ${media.mobile} {
    width: 100%;
  }
`;
